import { Phone, Globe, Navigation, Clock, Mail, Search, MapPin } from 'lucide-react';

export const HIRE_TYPES = [
  { id: 'all', label: 'All hire' },
  { id: 'plant', label: 'Plant & diggers', re: /plant|digger|excavat|groundforce|a-plant|hewden/i },
  { id: 'tool', label: 'Tool hire', re: /tool|speedy|hss|brandon|smiths|hire (centre|shop|station)|sunbelt|think hire|hire-equip/i },
  { id: 'access', label: 'Access & platforms', re: /access|platform|lavendon|nationwide|scaffold|cherry/i },
  { id: 'crane', label: 'Cranes', re: /crane/i },
  { id: 'skip', label: 'Skips', re: /skip/i },
  { id: 'power', label: 'Power & heating', re: /generator|power|sykes|heat|aggreko/i },
];

const enc = encodeURIComponent;

export function PlantHireCard({ p, index }) {
  const where = [p.name, p.postcode || p.town].filter(Boolean).join(' ');
  const directions = `https://www.google.com/maps/dir/?api=1&destination=${p.lat},${p.lng}`;
  const findPhone = `https://www.google.com/search?q=${enc(`${where} phone number`)}`;
  return (
    <li className="tm-card p-5 flex flex-col sm:flex-row gap-4 sm:items-start" data-testid={`plant-hire-card-${index}`}>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-display text-xl font-semibold text-slate-900" data-testid={`plant-hire-name-${index}`}>{p.name}</h3>
          <span className="tm-chip tm-chip-orange shrink-0" data-testid={`plant-hire-distance-${index}`}>{p.distance_miles} mi</span>
        </div>
        <p className="mt-1 text-sm text-slate-600 flex items-start gap-1.5"><MapPin size={14} className="mt-0.5 shrink-0 text-slate-400" /> {p.address}</p>
        {p.opening_hours && (
          <p className="mt-1 text-xs text-slate-500 flex items-start gap-1.5" data-testid={`plant-hire-hours-${index}`}>
            <Clock size={13} className="mt-0.5 shrink-0" /> {p.opening_hours.replace(/;\s*/g, ' · ')}
          </p>
        )}
        <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-sm">
          {p.phone ? (
            <a href={`tel:${p.phone.replace(/\s/g, '')}`} className="font-semibold text-slate-900 hover:text-brand flex items-center gap-1.5" data-testid={`plant-hire-phone-${index}`}>
              <Phone size={14} /> {p.phone.replace(/^\+44\s?/, '0')}
            </a>
          ) : (
            <a href={findPhone} target="_blank" rel="noreferrer" className="text-slate-500 hover:text-brand flex items-center gap-1.5" data-testid={`plant-hire-find-phone-${index}`}>
              <Search size={14} /> Find phone number
            </a>
          )}
          {p.email && (
            <a href={`mailto:${p.email}`} className="text-slate-600 hover:text-brand flex items-center gap-1.5" data-testid={`plant-hire-email-${index}`}><Mail size={14} /> {p.email}</a>
          )}
          {p.website && (
            <a href={p.website} target="_blank" rel="noreferrer" className="text-slate-600 hover:text-brand flex items-center gap-1.5" data-testid={`plant-hire-website-${index}`}><Globe size={14} /> Website</a>
          )}
        </div>
      </div>
      <div className="flex sm:flex-col gap-2 shrink-0">
        {p.phone && (
          <a href={`tel:${p.phone.replace(/\s/g, '')}`} className="tm-btn text-sm min-h-0 py-2 flex-1" data-testid={`plant-hire-call-${index}`}><Phone size={14} /> Call</a>
        )}
        <a href={directions} target="_blank" rel="noreferrer" className="tm-btn tm-btn-ghost text-sm min-h-0 py-2 flex-1" data-testid={`plant-hire-directions-${index}`}>
          <Navigation size={14} /> Directions
        </a>
      </div>
    </li>
  );
}
